import React from 'react';
import { Icon, Popconfirm, Tooltip } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import dataStorage from 'misc/data-storage';
import helpers from 'misc/helpers';

const propTypes = {
};

@autobind
class Header extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onLogOutClick() {
    dataStorage.clearCredential();

    helpers.showNotification('success', 'Success', 'You have successfully logged out.');

    // Reload current page.
    window.location.reload();
  }

  getCurrentUserName() {
    const user = dataStorage.getCurrentUser();
    if (user && !user.isEmpty()) {
      const userName = user.getString('userName');
      return userName.substring(0, userName.lastIndexOf('@')).toUpperCase();
    } else {
      return 'Guest';
    }
  }

  renderContent() {
    const { ...layoutProps } = this.props;

    return (
      <FlexRowContainer
        {...layoutProps}
        width="match_parent" // Needed because layoutProps maybe empty when switching route.
        height="match_parent" // Needed because layoutProps maybe empty when switching route.
        justifyContent="flex-end"
        alignItems="center"
      >
        <styledComp.Span
          width="wrap_content"
          height="wrap_content"
          margin="0 16px 0 0"
          color="textPrimaryLight"
          fontSize="16px"
        >
          {`Welcome, ${this.getCurrentUserName()}`}
        </styledComp.Span>

        <Tooltip title="Log out">
          <Popconfirm
            title="Are you sure you want to log out?"
            placement="top"
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={this.onLogOutClick}
          >
            <CustomButton
              width="64px"
              height="64px"
              backgroundColor="#001529"
              fontSize="20px"
              type="primary"
            >
              <Icon type="logout" />
            </CustomButton>
          </Popconfirm>
        </Tooltip>
      </FlexRowContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
Header.propTypes = propTypes;

export default Header;
